import {svgIconWrapper} from '../svg-icon-wrapper';

import KebabRegular from './kebab-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <KebabRegular {...validProps} />;
}
SvgComponent.iconName = 'kebabRegular';

export const KebabRegularIcon = svgIconWrapper(SvgComponent);
